import {Box, Link} from "@mui/material";
import {faLink, faTasks} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Image from "next/image";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import type ArticleIndexingSource from "@/src/_types/Article/article-indexing-source";
import NextLink from "next/link";

const ArticleIndexingSources = (
    {
        indexingSources
    }: {
        indexingSources: ArticleIndexingSource[];
    }
) => (
    <Box mt={1}>
        <StyledDivider
            label={"Indexed in"}
            icon={faTasks}
        />
        {
            indexingSources?.map((
                indexingSource: ArticleIndexingSource,
                id: number
            ) => (
                <Box
                    key={`indexing-${id}`}
                    display="flex"
                    alignItems="center"
                    pl={1}
                    mb={.5}
                >
                    {
                        indexingSource.logo ? (
                            <Image
                                src={indexingSource.logo}
                                alt="logo"
                                width={25}
                                height={25}
                                style={{
                                    marginRight: "8px"
                                }}
                            />
                        ) : (
                            <SpanTypography
                                color="primary"
                            >
                                <FontAwesomeIcon
                                    icon={faLink}
                                />
                            </SpanTypography>
                        )}
                    <Link
                        component={NextLink}
                        href={indexingSource.link}
                        target="_blank"
                        rel="noopener"
                        fontSize={'.8rem'}
                        display="inline"
                    >
                        {
                            indexingSource.title
                        }
                    </Link>
                </Box>
            ))
        }
    </Box>
);

export default ArticleIndexingSources;